import axios from '@/axios.js';
import constants from '@/constants.js';


export default {
  // async createKanban({ commit }, { kanbanInitialData }) {
  //   try {
  //     const resObj = await axios.post(`${constants.apiHost}/kanban`, kanbanInitialData);
  //     commit('SET_KANBAN_DATA', resObj.data);
  //     return resObj;
  //   } catch (error) {
  //     throw error;
  //   }
  // },
  // async fetchKanbanDatabyId({ commit }, { kanbanId }) {
  //   try {
  //     const resObj = await axios.get(`${constants.apiHost}/kanban/${kanbanId}`);
  //     commit('SET_KANBAN_DATA', resObj.data);
  //     return resObj.data;
  //   } catch (error) {
  //     throw error;
  //   }
  // },
  // async fetchKanbanDatabyBoardId({ commit }, { boardId }) {
  //   try {
  //     const resObj = await axios.get(`${constants.apiHost}/kanban`, { params: { boardId } });
  //     commit('SET_KANBAN_DATA', resObj.data.data[0]);
  //     return resObj.data;
  //   } catch (error) {
  //     throw error;
  //   }
  // },
  // async onlyFetchKanbanDatabyBoardId({ commit }, { boardId }) {
  //   try {
  //     const resObj = await axios.get(`${constants.apiHost}/kanban`, { params: { boardId } });
  //     return resObj.data;
  //   } catch (error) {
  //     throw error;
  //   }
  // },
  // async updateKanban({ commit }, { kanbanId, cols }) {
  //   try {
  //     const resObj = await axios.patch(`${constants.apiHost}/kanban/${kanbanId}`, { cols });
  //     commit('SET_KANBAN_DATA', resObj.data);
  //     return resObj;
  //   } catch (error) {
  //     throw error;
  //   }
  // },
  async fetchKanbanStats({ commit }, { boardId }) {
    try {
      const resObj = await axios.get(`${constants.acticsServiceUrl}/anics/kanban/${boardId}`);
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
  async saveUserNote({ commit }, { kanbanObj, boardTitle, boardUserName, organizationId }) {
    try {
      const resObj = await axios.post(`${constants.apiHost}/kanban-notes`, kanbanObj);

      // log activity
      const logPayload = {};
      logPayload['organizationId'] = organizationId;
      const logText = `Added a note to ${boardTitle} board user - ${boardUserName}`;
      axios.post(`${constants.apiHost}/actvt-log`, {logText, ...logPayload});

      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
  async fetchAllUserNotes({ commit }, { boardUserId, kanbanId }) {
    try {
      const resObj = await axios.get(`${constants.apiHost}/kanban-notes`, { params: { boardUserId, kanbanId } });
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
  async deleteUserNote({ commit }, { kanbanNoteId, boardTitle, boardUserName, organizationId }) {
    try {
      const resObj = await axios.delete(`${constants.apiHost}/kanban-notes/${kanbanNoteId}`);

      // log activity
      const logPayload = {};
      logPayload['organizationId'] = organizationId;
      const logText = `Deleted their note from ${boardTitle} board user - ${boardUserName}`;
      axios.post(`${constants.apiHost}/actvt-log`, {logText, ...logPayload});

      return resObj;
    } catch (error) {
      throw error;
    }
  },

  ////////////////////////
  // Kanban V2
  ////////////////////////

  async createKanbanV2({ commit }, kanbanInitialData) {
    try {
      const resObj = await axios.post(`${constants.gatewayServiceUrl}/boards/kanban`, kanbanInitialData);
      commit('SET_KANBAN_DATA', resObj.data);
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async getKanbanDataV2({ commit }, boardId) {
    try {
      const resObj = await axios.get(`${constants.gatewayServiceUrl}/boards/kanban/${boardId}`);
      commit('SET_KANBAN_DATA', resObj.data.data);
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async addUserToInitialPhaseV2({ commit }, payload) {
    try {
      await axios.post(`${constants.gatewayServiceUrl}/boards/kanban/user`, payload);
      const resObj = await axios.get(`${constants.gatewayServiceUrl}/boards/kanban/${payload.boardId}`);
      commit('SET_KANBAN_DATA', resObj.data.data);
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async updateKanbanV2({ commit }, payload) {
    try {
      await axios.patch(`${constants.gatewayServiceUrl}/boards/kanban/${payload.boardId}`, payload);
      const resObj = await axios.get(`${constants.gatewayServiceUrl}/boards/kanban/${payload.boardId}`);
      commit('SET_KANBAN_DATA', resObj.data.data);
      return resObj;
    } catch (error) {
      throw error;
    }
  },
}
